<template>
  <div>
    <Navbar v-if="!isShare" title="" :backNative="isApp"></Navbar>

    <van-pull-refresh
      v-model="refreshing"
      style="min-height: 100vh"
      @refresh="onRefresh"
    >
      <div class="detailMain">
        <div class="userInfo">
          <div class="avater-box">
            <div class="avater">
              <img
                :src="
                  detail.memberAvatar
                    ? detail.memberAvatar
                    : require('../../assets/images/default.png')
                "
                width="100%"
                alt=""
              />
            </div>
            <div class="nameAndDate">
              <div class="name">{{ detail.memberName }}</div>
              <div class="date">{{ detail.releaseDate }}</div>
            </div>
          </div>
          <div class="options" v-if="detail.workType == 1">
            <img
              src="../../assets/images/options.png"
              alt=""
              @click="
                openReport(detail.workId, detail.memberName, detail.title)
              "
            />
          </div>
          <div class="learned" v-else>
            <!-- 已学习 <span>{{ obj.studyTime }}</span> 天 -->
          </div>
        </div>
        <div class="content">
          <div class="text">
            {{ detail.title }}
          </div>
          <div class="photoOrVedio">
            <div class="videoInfo" v-if="detail.video">
              <video
                :src="detail.video"
                :poster="detail.image"
                controls
              ></video>
            </div>
            <div class="photoBox" v-else>
              <div
                class="photo"
                v-for="(item, index) in images"
                :key="index"
                :style="{
                  background: 'url(' + item + ') no-repeat center center',
                  'background-size': '100% 100%',
                }"
                @click="imageWatch(index)"
              ></div>
            </div>
          </div>
          <div class="likeNumber">
            <span>{{ detail.workType == "1" ? "动态" : "作业" }}</span>
            <span class="center">丨</span>
            <span>获赞{{ detail.praise }}</span>
            <span class="center">丨</span>
            <span>评论{{ detail.commentNum }}</span>
          </div>
        </div>
      </div>
      <div class="analyse" v-if="obj.classesTypeId === 0">
        <div class="analyse_title">完整分析</div>

        <div class="analyse_list">
          <div class="analyse_card">
            <div>完整度</div>
            <div v-if="obj.integrity == 0 || isPass == 0">-</div>
            <img
              v-else
              :src="
                obj.integrity == 1
                  ? require('../../assets/images/pass.png')
                  : obj.integrity == 2
                  ? require('../../assets/images/tips_yellow.png')
                  : require('../../assets/images/nopass.png')
              "
              alt=""
            />
          </div>

          <div class="analyse_card">
            <div>和弦</div>
            <div v-if="obj.chord == 0 || isPass == 0">-</div>
            <img
              v-else
              :src="
                obj.chord == 1
                  ? require('../../assets/images/pass.png')
                  : obj.chord == 2
                  ? require('../../assets/images/tips_yellow.png')
                  : require('../../assets/images/nopass.png')
              "
              alt=""
            />
          </div>

          <div class="analyse_card">
            <div>熟练度</div>
            <div v-if="obj.skilled == 0 || isPass == 0">-</div>
            <img
              v-else
              :src="
                obj.skilled == 1
                  ? require('../../assets/images/pass.png')
                  : obj.skilled == 2
                  ? require('../../assets/images/tips_yellow.png')
                  : require('../../assets/images/nopass.png')
              "
              alt=""
            />
          </div>

          <div class="analyse_card">
            <div>指法</div>
            <div v-if="obj.fingering == 0 || isPass == 0">-</div>
            <img
              v-else
              :src="
                obj.fingering == 1
                  ? require('../../assets/images/pass.png')
                  : obj.fingering == 2
                  ? require('../../assets/images/tips_yellow.png')
                  : require('../../assets/images/nopass.png')
              "
              alt=""
            />
          </div>

          <div class="analyse_card">
            <div>节奏</div>
            <div v-if="obj.rhythm == 0 || isPass == 0">-</div>
            <img
              v-else
              :src="
                obj.rhythm == 1
                  ? require('../../assets/images/pass.png')
                  : obj.rhythm == 2
                  ? require('../../assets/images/tips_yellow.png')
                  : require('../../assets/images/nopass.png')
              "
              alt=""
            />
          </div>

          <div class="analyse_card">
            <div>手型</div>
            <div v-if="obj.handshape == 0 || isPass == 0">-</div>
            <img
              v-else
              :src="
                obj.handshape == 1
                  ? require('../../assets/images/pass.png')
                  : obj.handshape == 2
                  ? require('../../assets/images/tips_yellow.png')
                  : require('../../assets/images/nopass.png')
              "
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- 教师点评 -->
      <div class="teacherComment" v-if="isPass != 0">
        <img
          class="commentIcon"
          src="../../assets/images/commentIcon.png"
          alt=""
        />
        <div class="comment_word">{{ obj.teacherReview }}</div>

        <div class="picsList" v-if="obj.teacherPicture.length > 0">
          <div
            class="picItem"
            v-for="(items, index) in obj.teacherPicture"
            @click="watchPic(index)"
            :key="index"
            :style="{
              background:
                'url(' +
                obj.teacherPicture[index] +
                ') no-repeat center center',
              backgroundSize: '100% auto',
            }"
          ></div>
        </div>

        <div class="line"></div>

        <div class="teacherAvatar">
          <img
            :src="
              detail.teacherAvatar
                ? obj.teacherAvatar
                : require('../../assets/images/default.png')
            "
            alt=""
          />
          <div>{{ obj.teacherName }}</div>
        </div>
      </div>
  </van-pull-refresh>
  </div>
</template> 
 
<script>
import Navbar from "../../components/NavBar";
import { ImagePreview, Notify, Toast } from "vant";
import http from "../../utils/http";

export default {
  name: "",
  components: {
    Navbar,
  },
  data() {
    return {
      detail: {}, // 详情
      like: 0, // 当前用户是否点赞
      talkList: [], // 评论列表
      bannerList: [], //广告列表
      commentValue: "", // 评论输入框值
      inputFocus: false, //评论输入框是否聚焦
      images: [], // 九宫格图片
      likeModalFlag: false, // 控制点赞模态框的开关
      list: [],
      commentType: 0, // 判断是回复用户还是回复文章
      replyMemberId: "", // 被回复的人的id
      parentId: "", // 回复别人的评论时，一级评论的id
      commentList: [], //回复列表
      isShare: false, // 是否是分享页
      show: false, //分享弹框
      refreshing: false, //是否正在刷新
      reportShow: false, // 举报flag
      size: 20,
      current: 1,
      userName: "",
      loading: false,
      finished: false,
      reportId: "", // 被举报的id
      reportText: "", //被举报的内容
      workId: "",
      isApp: false,
      isPass: "", //是否通过审核
      obj: [],
      showBanner: false,
      userId: "",
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    onLoad() {
      if (this.refreshing) {
      } else {
        this.current++;
      }
      this.getDetail();
    },
    onRefresh() {
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = false;
      this.current = 1;
      this.onLoad();
    },
    // 点击图片展示大图
    imageWatch(index) {
      ImagePreview({
        images: this.images,
        startPosition: index,
        loop: false,
      });
    },
    getDetail() {
      http
        .getMenberDetail({
          size: this.size,
          current: this.current,
          workId: this.$route.query.id,
        })
        .then((res) => {
          this.refreshing = false;
          // console.log(res);
          this.detail = res.communityWorkVo; // 详情
          this.like = res.giveALike; // 当前用户是否点赞
          this.bannerList = res.bannerList; //广告列表
          // this.playerOptions.poster = this.detail.image; //视频封面
          // this.playerOptions["sources"][0]["src"] = this.detail.video; //视频路径
          if (!res.communityWorkVo.video) {
            if (res.communityWorkVo.image) {
              let imgList = res.communityWorkVo.image.split(",");
              this.images = imgList;
            }
          }
        //   if (this.detail.workType == 0) {
        //     http
        //       .getMemberWorkVO({
        //         classType: this.$route.query.classType,
        //         MemberWorkId: this.$route.query.id,
        //       })
        //       .then((res) => {
        //         this.isPass = res.status;
        //         this.obj = res;
        //         if (res.teacherPicture) {
        //           this.obj.teacherPicture = res.teacherPicture.split(",");
        //         } else {
        //           this.obj.teacherPicture = [];
        //         }
        //       });
        //   }
          setTimeout(() => {
            if (res.workMemberCommentVOList.length > 0) {
              if (this.refreshing || this.current == 1) {
                this.commentList = [...res.workMemberCommentVOList];
                this.refreshing = false;
              } else {
                this.commentList = [
                  ...this.commentList,
                  ...res.workMemberCommentVOList,
                ];
              }

              this.loading = false;
            } else {
              this.finished = true;
              this.refreshing = false;
              this.current--;
            }
          }, 500);
          // this.commentList = res.workMemberCommentVOList;
        });
    },
    // 预览图片
    watchPic(index) {
      ImagePreview({
        images: this.obj.teacherPicture,
        startPosition: index,
        loop: false,
      });
    },
  },
  mounted() {
    if (this.$route.query.isShare) {
      this.isShare = this.$route.query.isShare;
    }
    if (this.$route.query.showBanner) {
      this.showBanner = this.$route.query.showBanner;
    }
    if (this.$route.query.isApp) {
      this.isApp = true;
    }
  },
};
</script>

<style scoped lang='less'>
.detailMain {
  border-bottom: 1px solid #f0f0f1;
  margin: 10px 16px;
  box-sizing: border-box;
  .userInfo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    .avater-box {
      display: flex;
    }
    .avater {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 12px;
    }
    .options {
      left: 0px;
      top: 0px;
      width: 14px;
      img {
        right: 10px;
        width: 100%;
      }
    }
    .nameAndDate {
      height: 40px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        color: #222;
        font-size: 15px;
        font-weight: 600;
      }
      .date {
        color: rgba(34, 32, 48, 0.45);
        font-size: 12px;
      }
    }
    .learned {
      color: #9b9aa2;
      font-size: 11px;
      span {
        font-size: 20px;
        color: #fc541e;
        font-weight: bold;
      }
    }
  }
  .content {
    .text {
      color: #222030;
      font-weight: 400;
      font-size: 15px;
      margin: 10px 0;
    }
    .photoOrVedio {
      margin-bottom: 14px;
      .photoBox {
        border-radius: 6px 6px 6px 6px;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        .photo {
          // background-color: red;
          overflow: hidden;
          width: calc(98% / 3);
          margin-right: 1%;
          &:nth-child(3n) {
            margin-right: 0;
          }
          margin-bottom: 1%;
          padding-top: 33%;
          // img {
          //   width: 100%;
          //   display: block;
          // }
        }
      }
      .videoInfo {
        width: 100%;
        margin: 0 auto;
        margin-top: 12px;
        video {
          width: 100%;
          height: 194px;
          border-radius: 10px;
          object-fit: cover;
        }
      }
    }
    .likeNumber {
      margin-bottom: 20px;
      span {
        font-size: 13px;
        color: rgba(34, 32, 48, 0.45);
        font-weight: 400;
      }
    }
  }
}

.analyse {
  width: calc(100% - 32px);
  margin: 0 auto;
  margin-top: 22px;
  .analyse_title {
    font-size: 20px;
    font-weight: 600;
  }
  .analyse_list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 12px;
    .analyse_card {
      width: 167px;
      height: 40px;
      padding: 0 16px;
      box-sizing: border-box;
      background: #f6f6f6;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      div {
        font-size: 15px;
        color: #222030;
      }
      img {
        width: 16px;
        height: 16px;
      }
    }
    .analyse_card:nth-child(odd) {
      border-radius: 6px 0px 0px 0px;
    }
    .analyse_card:nth-child(even) {
      border-radius: 0px 6px 0px 0px;
    }
  }
}
.teacherComment {
  width: calc(100% - 32px);
  margin: 0 auto;
  padding: 16px;
  box-sizing: border-box;
  background: #f6f6f6;
  border-radius: 6px;
  margin-bottom: 24px;
  .commentIcon {
    width: 60px;
    height: 15px;
  }
  .comment_word {
    font-size: 15px;
    color: #222030;
    margin-top: 18px;
  }
  .picsList {
    display: flex;
    margin-top: 12px;
    .picItem {
      width: 42px;
      margin-left: 3px;
      height: 42px;
      &:nth-of-type(1) {
        margin: 0;
      }
    }
  }

  .teacherAvatar {
    display: flex;
    align-items: center;
    margin-top: 8px;
    img {
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }
    div {
      font-size: 12px;
      margin-left: 8px;
      color: #6c6b75;
    }
  }
}
.line {
  width: 100%;
  height: 1px;
  background: #e1e1e3;
  margin-top: 12px;
}
</style>